import {WidgetController} from "../widgetController";

const updateDelayInMillisecond = 1200;

export class BulletWidgetController extends WidgetController {
  constructor(componentId, legends, updateCallback) {
    super(componentId, legends);
    this.historySize = 1;
    this.updateCallback = updateCallback;
  }

  loadHistoricData(historicData) {
    let convertedData = {};
    for (let datasetId in historicData) {
      convertedData[datasetId] = historicData[datasetId][0];
    }
    const data = this.processData(convertedData);
    this.latestData = data;
    this.updateCallback(data);
    this.updateCallback(this.latestData);
  }

  update() {
    this.latestData = this.processData();

    if (this.updateTimer) clearTimeout(this.timer);
    this.updateTimer = setTimeout(() => {
      this.updateCallback(this.latestData);
    }, updateDelayInMillisecond);
  }

  getHistorySize() {
    return this.historySize;
  }

  getLegends() {
    return this.legends;
  }

  onLegendUpdated() {
    // force update tree map
    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.updateCallback(this.latestData);
    }, 300);
  }

  destroy() {
    clearTimeout(this.updateTimer);
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/bullet/controller.js